var JoyUserRole;
(function (JoyUserRole) {
    JoyUserRole["owner"] = "owner";
    JoyUserRole["subscriber"] = "subscriber";
})(JoyUserRole || (JoyUserRole = {}));
export default JoyUserRole;
//# sourceMappingURL=JoyUserRole.js.map